import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const BuildingIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M3 3.5h12.942v17H3v-17Zm5.764 5.717H5.933V7.7h2.831v1.518Zm1.416 0h2.831V7.7H10.18v1.518Zm-4.247 3.036h2.831v-1.518H5.933v1.518Zm4.247 0h2.831v-1.518H10.18v1.518Zm-4.247 3.036h2.831V13.77H5.933v1.518Zm4.247 0h2.831V13.77H10.18v1.518Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            ),
            /* @__PURE__ */ jsx("path", { fill: color, d: "M21 20.5h-3.54V8.56H21V20.5Z" })
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M5.933 9.217h2.831V7.7H5.933v1.518ZM13.011 9.217H10.18V7.7h2.831v1.518ZM5.933 12.253h2.831v-1.518H5.933v1.518ZM13.011 12.253H10.18v-1.518h2.831v1.518ZM5.933 15.289h2.831V13.77H5.933v1.518ZM13.011 15.289H10.18V13.77h2.831v1.518Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M15.944 3.5H3v17h18V8.56h-5.056V3.5Zm0 6.881v1.366h1.921v1.518h-1.921v1.518h1.921V16.3h-1.921v2.378h3.236V10.38h-3.236Zm-1.82-5.06H4.82V18.68h9.304V5.32Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `BuildingIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { BuildingIcon };
//# sourceMappingURL=BuildingIcon.mjs.map
